/* eslint-disable max-len */
import { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const Play: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.2583 3.69829V16.3016C3.2583 17.2191 4.2483 17.7958 5.0458 17.3425L16.1358 11.0408C16.9433 10.5825 16.9433 9.41829 16.1358 8.95996L5.0458 2.65746C4.2483 2.20412 3.2583 2.78079 3.2583 3.69829Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
/* eslint-enable max-len */
